import { clsx } from 'clsx';

import DurationTag from '~/src/common/components/Recipe/DurationTag';
import TypeTag from '~/src/common/components/Recipe/TypeTag';
import { Tag } from '~/src/common/components/Tag/Tag';
import { GetRecipeByIdOrSlug200 } from '~/src/queries/api-ecom/generated/api-ecom.schemas';

import screenStyles from '../../RecipeScreen.module.scss';

import styles from './RecipeNameAndTags.module.scss';

interface Props {
  recipe: GetRecipeByIdOrSlug200;
}

export const RecipeNameAndTags = (props: Props) => (
  <div className={clsx(styles.container, screenStyles.nameAndTagsGridPosition)}>
    <div className={styles.tags}>
      {props.recipe.cookTypes.map(tag => (
        <Tag key={tag} bgColor="FLAG_PROMO" fgColor="NEUTRAL_DEFAULT">
          {tag}
        </Tag>
      ))}
      <TypeTag recipeType={props.recipe.recipeType} />
      <DurationTag duration={props.recipe.cookingTime + props.recipe.preparationTime} />
    </div>
    <h1 className={styles.catalogItemName}>{props.recipe.name}</h1>
  </div>
);
